import React, { useState } from 'react';
import Sidebar from './Sidebar';

export default function AppLayout({ children }) {
  const [collapsed, setCollapsed] = useState(false);

  return (
    <div className="flex min-h-screen" style={{ background: 'var(--color-background)' }}>
      <Sidebar collapsed={collapsed} onToggle={() => setCollapsed((p) => !p)} />
      {/* Mobile: no margin (sidebar overlays). Desktop: margin matches sidebar width */}
      <main
        className={`flex-1 min-w-0 transition-all duration-300 ease-in-out ${collapsed ? 'lg:ml-16' : 'lg:ml-60'}`}
      >
        {/* Spacer for mobile hamburger button */}
        <div className="lg:hidden" style={{ height: '56px' }} />
        {children}
      </main>
    </div>
  );
}
